import type { RouteRecordRaw } from 'vue-router'

import { keys } from '@/app/i18n'

/**
 * The onboarding module's routes (wp/onboarding §3, manifest rows of WP-16; paths and names from the manifest, D-15).
 * Under Human resources since 2026-11-03 (owner's call, BR-097: Onboarding is no longer a software of its own): the
 * legacy `/on/onboarding/:id` and `/on/offboarding/:id` redirect here through `src/app/router/legacy-redirects.ts`,
 * the `:id` stage filter becoming `?stage=`, and any other `/on/…` address through the shell's catch-all redirect.
 * One board view serves both routes (§1.1); the pipeline is a route prop. The route guard needs the board's own
 * pipeline read (D-21; legacy set no `meta.roles`, NEW-18 / OPEN-9).
 */
const BoardView = () => import('./views/BoardView.vue')

const routes: RouteRecordRaw[] = [
  {
    path: '/hr/onboarding',
    name: 'onboarding',
    component: BoardView,
    props: { pipeline: 'onboarding' },
    meta: {
      software: 'hr',
      resource: 'onboarding',
      pageTitle: keys.t('onboarding.board.title.onboarding'),
      breadcrumb: [{ text: keys.t('onboarding.board.title.onboardingList'), active: true }],
    },
  },
  {
    path: '/hr/offboarding',
    name: 'offboarding',
    component: BoardView,
    props: { pipeline: 'offboarding' },
    meta: {
      software: 'hr',
      resource: 'offboarding',
      pageTitle: keys.t('onboarding.board.title.offboarding'),
      breadcrumb: [
        // NEW-13: legacy linked `/on/offboarding`, which no legacy route matched (→ 404); here the board's All tile.
        { text: keys.t('onboarding.board.title.offboardingList'), to: '/hr/offboarding?stage=0' },
        { text: keys.t('onboarding.board.title.offboarding'), active: true },
      ],
    },
  },
]

export default routes
